<form [formGroup]="parentFormGroup">
  <mat-form-field class="service-selector-control">
    <mat-select multiple [formControlName]="controlName">
      @for (item of services$ | async; track item.serviceId) {
        <mat-option [value]="item.serviceId">
          {{item.serviceLabel}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
